import { render } from "./CreateUserConfirmRule.vue?vue&type=template&id=620ef12d&scoped=true"
import script from "./CreateUserConfirmRule.vue?vue&type=script&lang=js"
export * from "./CreateUserConfirmRule.vue?vue&type=script&lang=js"

import "./CreateUserConfirmRule.vue?vue&type=style&index=0&id=620ef12d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620ef12d"]])

export default __exports__